export const getODataConfig = (serverContext) => {
  const isLocal = () => {
    const hostname = document.location.hostname.toLowerCase();
    return hostname.indexOf('ads.microsoft.com') === -1 &&
        hostname.indexOf('ads-int.microsoft.com') === -1;
  };

  const odataPath = isLocal() ? 'Advertiser/V2' : 'Campaign/V2';

  const oDataConfig = {
    odataToken: serverContext.Token,
    oDataToken: serverContext.Token,
    odataPath: `${serverContext.ServicesEndpoints.CampaignAPI}${odataPath}`,
    oDataPath: `${serverContext.ServicesEndpoints.CampaignAPI}${odataPath}`,
  };

  return oDataConfig;
};
